export default (value: string) => {
  return value.replace(/_([a-z])/g, function(substring) {
    return substring[1].toUpperCase();
  });
};
